import { render, staticRenderFns } from "./SnsPostLoaderParts.vue?vue&type=template&id=6fbc00c7&scoped=true"
import script from "./SnsPostLoaderParts.vue?vue&type=script&lang=ts"
export * from "./SnsPostLoaderParts.vue?vue&type=script&lang=ts"
import style0 from "./SnsPostLoaderParts.vue?vue&type=style&index=0&id=6fbc00c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbc00c7",
  null
  
)

export default component.exports